import styled from '@emotion/styled'
import { color, device, H1, H3, space } from '@ticketswap/solar'

export const StyledCover = styled.div`
  padding-bottom: ${space[24]};
  position: relative;
  padding: ${space[64]} 0 300px;
  margin-bottom: -300px;
  text-align: center;
  color: ${color.nova};
  overflow-x: hidden;

  &:after {
    content: '';
    width: 200%;
    height: calc(100% - ${space[24]} - 280px);
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    border-radius: 0 0 50% 50%;
    background-color: ${color.earth};

    [data-theme='dark'] & {
      background-color: ${color.skyLight};
    }

    @media ${device.mobileL} {
      width: 120%;
    }
  }
`

export const Title = styled(H1)`
  margin: ${space[32]} 0 0;
  color: ${color.nova};

  [data-theme='dark'] & {
    color: ${color.space};
  }

  @media ${device.tablet} {
    margin-bottom: ${space[24]};
    display: block;
    margin: ${space[32]} auto ${space[16]};
  }
`

export const Description = styled(H3)`
  margin: ${space[4]} 0 ${space[16]};
  display: block;
  font-weight: normal;
  color: ${color.nova};

  [data-theme='dark'] & {
    color: ${color.space};
  }

  @media ${device.tablet} {
    margin: 0 auto ${space[32]};
  }
`
